import React from 'react';
import './PackageSelectionSection.css';
import { isDiwaliOfferActive, getRegularPlanEffectivePrice } from '../utils/offers';

const packages = [
  {
    name: 'Hourly Plan',
    image: '/images/1.jpeg', // Using gallery image 1
    options: [
      { label: '1 Hour', price: 199 },
      { label: '3 Hours', price: 349 },
      { label: '5 Hours', price: 499 }
    ]
  },
  {
    name: 'Regular Plan',
    image: '/images/2.jpeg', // Using gallery image 2
    options: [
      { label: '12-24 Hours', price: 599 }
    ]
  },
  {
    name: 'Weekly Plan',
    image: '/images/3.jpeg', // Using gallery image 3
    options: [
      { label: '7 Days', price: 3499 }
    ]
  },
  {
    name: 'Monthly Plan',
    image: '/images/4.jpeg', // Using gallery image 4
    options: [
      { label: '30 Days', price: 11999 }
    ]
  }
];

export default function PackageSelectionSection({ onSelect }) {
  const diwaliActive = isDiwaliOfferActive();
  return (
    <section className="package-selection-section">
      <h2 className="package-title">Choose Your Stay Package</h2>
      <p className="package-subtitle">Select the perfect plan that suits your travel needs</p>
      <div className="package-cards">
        {packages.map((pkg) => (
  <div className="package-card" key={pkg.name}>
    <div className="package-image-wrapper">
      <img
        className="package-image"
        src={pkg.image}
        alt={pkg.name + ' visual'}
        onError={e => {
          e.target.onerror = null;
          e.target.src = 'https://placehold.co/260x140?text=Package';
        }}
      />
    </div>
    <div className="package-card-header">{pkg.name}</div>
    <div className="package-options">
      {pkg.options.map((opt) => (
        <button
          className="package-option-btn"
          key={opt.label}
          onClick={() => {
            // Always pass base price; discount is applied during booking calculations
            onSelect && onSelect({ plan: pkg.name, duration: opt.label, price: opt.price });
          }}
        >
          <div className="option-label">{opt.label}</div>
          <div className="option-price">
            {pkg.name === 'Regular Plan' && opt.label.includes('12-24') && diwaliActive ? (
              <>
                <span style={{ textDecoration: 'line-through', opacity: 0.8, marginRight: 6 }}>₹{opt.price}</span>
                <span style={{ fontWeight: 800 }}>₹{getRegularPlanEffectivePrice(opt.price)}</span>
              </>
            ) : (
              <>₹{opt.price}</>
            )}
          </div>
        </button>
      ))}
    </div>
  </div>
))}
      </div>
    </section>
  );
}
